'use client'

import React, { createContext, useContext } from 'react'
import { useEventEmitter } from 'ahooks'
import { AppEvent } from '@/lib/events/events'

const EventEmitterContext = createContext<ReturnType<typeof useEventEmitter<AppEvent>> | undefined>(undefined)

export const EventEmitterProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const eventEmitter = useEventEmitter<AppEvent>()

  return <EventEmitterContext.Provider value={eventEmitter}>{children}</EventEmitterContext.Provider>
}

export const useEventEmitterContext = () => {
  const context = useContext(EventEmitterContext)
  if (context === undefined) {
    throw new Error('useEventEmitterContext must be used within an EventEmitterProvider')
  }
  return context
}
